// Example address segment
// { "long_name": "Brooklyn", "short_name": "Brooklyn", "types": [ "sublocality_level_1", "sublocality", "political"] }
export function filterSegment(
  address: google.maps.GeocoderAddressComponent[],
  keys: string[]
) {
  return address.find((segment) =>
    keys?.find((key) => segment?.types?.includes(key))
  );
}
